import { collectData } from "features/collector";
import { logError } from "features/logger";
import { fetchTemplatePageData } from "shared/utils";

import { singlePageDataFetcher } from "../SinglePage";

const TEMPLATE_PATH = {
  "/events": "/event-template",
  "/courses": "/course-template",
  "/articles": "/article-template",
};

export async function fixedPageDataFetcher(context, options) {
  const { locale, query } = context;

  const shouldDebugResponse = context?.query?._debugResponse === "1";

  try {
    const {
      props: { data, error, debugData },
    } = await singlePageDataFetcher(context, {
      path: options.path,
    });

    const { templatedData } = await fetchTemplatePageData(
      { locale, debug: shouldDebugResponse },
      TEMPLATE_PATH[options.path]
    );

    const collectedData = await collectData(
      {
        items: [
          ...data.content,
          ...templatedData.content,
          ...templatedData.hero,
        ],
        context: {
          slug: query.slug,
          date: data.pageOwnData?.date,
          articleCategories: data.pageOwnData?.articleCategories,
        },
      },
      locale
    );

    if (error && error.status === 204) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        data,
        collectedData,
        templatedData,
        error,
        debugData,
      },
    };
  } catch (e) {
    logError(e, {
      scope: "templatePageDataFetcher",
      ...(options ?? {}),
    });
    return {
      props: {
        data: {},
        collectedData: {},
        templatedData: {},
        error: e,
        debugData: {
          error: {
            message: e.message,
            status: e.status,
          },
          response: null,
          scope:
            "Exception is caught inside during fetching a single page data",
        },
      },
    };
  }
}
